import { render, staticRenderFns } from "./company-list.vue?vue&type=template&id=3adac230"
import script from "./company-list.vue?vue&type=script&lang=ts"
export * from "./company-list.vue?vue&type=script&lang=ts"
import style0 from "./company-list.vue?vue&type=style&index=0&id=3adac230&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports